import { useForm } from "react-hook-form";
import { useState, useCallback } from "react";
import { SearchInputField } from "./Parts/index";
import classnames from "classnames";
import IconSearch from "../../../src/svgs/icon_search.svg";
import styles from "@/styles/Form.module.scss";
import { useDeviceInfoQuery } from "@/hooks";

export default function ChannelSearchFormSp({ onSubmit, ...props }) {
  const [focus, setFocus] = useState(false);
  const { register, handleSubmit } = useForm();
  const { data } = useDeviceInfoQuery({ fetchPolicy: "cache-first" });
  const deviceInfo = data?.deviceInfo;
  const handleKeyDown = useCallback(
    (e) => {
      // Return
      if (e.key === "Enter" && deviceInfo?.isMobile) {
        setTimeout(() => {
          e.target.blur();
        }, 200);
      }
    },
    [deviceInfo]
  );

  const handleFocus = useCallback(() => {
    setFocus(true);
  }, []);

  const handleBlur = useCallback(() => {
    setFocus(false);
  }, []);

  return (
    <form
      action="#"
      onSubmit={handleSubmit(onSubmit)}
      className={styles.channelSearchFormSp}
      noValidate
    >
      <button type="button" className={styles.showChannelSearchFormBtn}>
        <IconSearch />
      </button>
      <div
        className={classnames(styles.channelSearchFormSpInner, {
          [styles.focused]: focus,
        })}
      >
        <SearchInputField
          {...register("search")}
          placeholder="商品内検索"
          onKeyDown={handleKeyDown}
          onFocus={handleFocus}
          onBlur={handleBlur}
          {...props}
        />
      </div>
    </form>
  );
}
